export default "__VITE_ASSET__kTdD5XXM__"